import { isMobileDevice } from 'helpers/environment';

export const isShareApiAvailable = () =>
  isMobileDevice() && Boolean(navigator.share) && Boolean(navigator.canShare);

/**
 * Capability only, no device check: the redesign's share-link flow hands off to the share sheet
 * wherever the browser has one, desktop included, and falls back to the clipboard where it does not.
 */
export const isNativeShareAvailable = () =>
  Boolean(navigator.share) && Boolean(navigator.canShare);
